import React from "react";

const SpinContext = React.createContext();

export default SpinContext;




